import { useMemo, useState, useCallback } from 'react'

const INITIAL_FILTERS = {
  enrollmentStatuses: [],
  genders: [],
  categoryIds: [],
  courseIds: [],
  eventIds: [],
  levels: [],
  dateJoinedFrom: null,
  dateJoinedTo: null,
  ageFrom: null,
  ageTo: null,
}

export const buildApiFilters = (filters) => {
  const params = {}

  if (filters.enrollmentStatuses.length) { params.enrollmentStatuses = filters.enrollmentStatuses }
  if (filters.genders.length) { params.genders = filters.genders }
  if (filters.categoryIds.length) { params.categoryIds = filters.categoryIds }
  if (filters.courseIds.length) { params.courseIds = filters.courseIds }
  if (filters.eventIds.length) { params.eventIds = filters.eventIds }
  if (filters.levels.length) { params.levels = filters.levels }
  if (filters.dateJoinedFrom) { params.dateJoinedFrom = filters.dateJoinedFrom }
  if (filters.dateJoinedTo) { params.dateJoinedTo = filters.dateJoinedTo }
  if (filters.ageFrom !== null) { params.ageFrom = filters.ageFrom }
  if (filters.ageTo !== null) { params.ageTo = filters.ageTo }

  return params
}

const useStudentsFilters = () => {
  const [filters, setFilters] = useState(INITIAL_FILTERS)

  const apiFilters = useMemo(() => buildApiFilters(filters), [filters])

  const activeFilterCount = useMemo(() => {
    let count = 0

    if (filters.enrollmentStatuses.length) { count++ }
    if (filters.genders.length) { count++ }
    if (filters.categoryIds.length) { count++ }
    if (filters.courseIds.length || filters.eventIds.length) { count++ }
    if (filters.dateJoinedFrom || filters.dateJoinedTo) { count++ }
    if (filters.ageFrom !== null || filters.ageTo !== null) { count++ }
    if (filters.levels.length) { count++ }

    return count
  }, [filters])

  const applyFilters = useCallback((newFilters) => {
    setFilters(newFilters)
  }, [])

  const clearFilters = useCallback(() => {
    setFilters(INITIAL_FILTERS)
  }, [])

  return {
    filters,
    apiFilters,
    activeFilterCount,
    applyFilters,
    clearFilters,
    INITIAL_FILTERS,
  }
}

export default useStudentsFilters
